import React from 'react'
import { getRestaurantSettings } from '../../selectors'
import { useSelector } from 'react-redux'
import { formatCurrency, roundMoney } from '../../utils'
import { clsx } from '../../utils/helper'

const FormatCurrency = ({ amount, currency, tag = 'span', className = '' }) => {
    const {
        currentcy = '',
        decimal_separator = ',',
        group_separator = '.',
    } = useSelector(getRestaurantSettings)

    const validAmount = isNaN(Number(amount)) ? 0 : Number(amount)
    amount = formatCurrency(
        (roundMoney(validAmount).toFixed(2) + '').replace(/\./g, decimal_separator),
        group_separator
    )

    const DynamicComp = tag

    return (
        <DynamicComp className={clsx(['format-money', className])}>
            {amount + ' ' + (currency || currentcy)}
        </DynamicComp>
    )
}

export default FormatCurrency
